<template>
  <div
    class="chat-message"
    :class="{
      'chat-message--received': wasReceived,
      'chat-message--sent': !wasReceived,
    }"
  >
    <div
      class="chat-message__bubble"
      :class="{
        'chat-message__bubble--received': wasReceived,
        'chat-message__bubble--sent': !wasReceived,
      }"
    >
      {{ message.message }}
    </div>
    <small class="chat-message__time">
      {{ time }}
    </small>
  </div>
</template>

<script>
import moment from "moment"

export default {
  name: "ChatMessage",
  props: {
    message: {
      type: Object,
    },
  },
  computed: {
    wasReceived() {
      return !this.message.from_manager;
    },
    time() {
      return moment(this.message.created_at).format('HH:mm - DD MMM YYYY');
    },
  },
};
</script>

<style lang="scss" scoped>
.chat-message {
  margin-bottom: 0.75rem;
  display: flex;
  flex-direction: column;
  max-width: 80%;

  &--received {
    margin-right: auto;
  }

  &--sent {
    margin-left: auto;
  }

  &__bubble {
    padding: 0.5rem;
    border-radius: 5px;
    display: inline-block;

    &--received {
      background-color: rgba(0, 0, 0, 0.1);
      margin-right: auto;
    }

    &--sent {
      background: #d83039;
      color: #fff;
      margin-left: auto;
    }
  }

  &__time {
    display: block;
    font-weight: 65%;
    color: rgba(0, 0, 0, 0.6);
  }
}
</style>
